import axios from "axios";
import {
  fetchVisionStart,
  fetchVisionSuccess,
  fetchVisionFailure,
  fetchLeadershipMessagesStart,
  fetchLeadershipMessagesSuccess,
  fetchLeadershipMessagesFailure,
  updateLeadershipMessage,
  deleteLeadershipMessage,
  addLeadershipMessageStart,
  addLeadershipMessageSuccess,
  addLeadershipMessageFailure,
  addCouncilMemberStart,
  addCouncilMemberSuccess,
  addCouncilMemberFailure,
  fetchCouncilMemberStart,
  fetchCouncilMemberSuccess,
  fetchCouncilMemberFailure,
  updateCouncilMemberSuccess,
  updateCouncilMemberFailure,
  updateCouncilMemberStart,
  addBoardMemberStart,
  addBoardMemberSuccess,
  addBoardMemberFailure,
  fetchBoardMemberStart,
  fetchBoardMemberSuccess,
  fetchBoardMemberFailure,
  updateBoardMemberStart,
  updateBoardMemberSuccess,
  updateBoardMemberFailure,
  addStudiesMemberStart,
  addStudiesMemberSuccess,
  addStudiesMemberFailure,
  fetchStudiesMemberStart,
  fetchStudiesMemberSuccess,
  fetchStudiesMemberFailure,
  updateStudiesMemberStart,
  updateStudiesMemberSuccess,
  updateStudiesMemberFailure,
  fetchHistoryStart,
  fetchHistorySuccess,
  fetchHistoryFailure,
  updateHistoryStart,
  updateHistorySuccess,
  updateHistoryFailure,
} from "../slicer/aboutUsSlicer";

const getToken = () =>
  document.cookie
    .split("; ")
    .find((row) => row.startsWith("accessToken="))
    ?.split("=")[1];

// Helper function to get the auth headers
const getAuthHeaders = () => {
  const token = getToken();
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

export const fetchVisionData = () => async (dispatch) => {
  console.log("This is action");
  dispatch(fetchVisionStart()); // Set loading state
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/aboutPage/getVision`,
      getAuthHeaders() // Added authentication headers
    );
    const visionData = response?.data?.data?.[0] || {}; // Safely access response data
    dispatch(fetchVisionSuccess(visionData)); // Dispatch success action with data
  } catch (error) {
    console.error("Error fetching vision data:", error);
    dispatch(fetchVisionFailure(error.response?.data?.message || "Failed to fetch vision data"));
  }
};

export const updateVisionData = (id, vision, mission) => async (dispatch) => {
  dispatch(fetchVisionStart()); // Start updating
  try {
    await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/aboutPage/updateVision/${id}`,
      { vision, mission },
      getAuthHeaders() // Added authentication headers
    );
    dispatch(fetchVisionSuccess({ vision, mission })); // Update state with new data
    alert("Vision and Mission updated successfully!"); // Success alert
  } catch (error) {
    console.error("Error updating vision data:", error);
    dispatch(fetchVisionFailure(error.message || "Something went wrong"));
    alert(`Error updating Vision and Mission: ${error.message || "Something went wrong"}`); // Error alert
  }
};

// Fetch Leadership Messages
export const fetchLeadershipMessages = () => async (dispatch) => {
  dispatch(fetchLeadershipMessagesStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/aboutPage/getLeadershipMessages`,
      getAuthHeaders() // Added authentication headers
    );
    //console.log(response.data)
    const messages = response?.data?.data || [];
    dispatch(fetchLeadershipMessagesSuccess(messages));
  } catch (error) {
    console.error("Error fetching leadership messages:", error);
    dispatch(
      fetchLeadershipMessagesFailure(
        error.response?.data?.message || "Failed to fetch leadership messages"
      )
    );
  }
};

// Update Leadership Message
export const updateLeadershipMessageById = (id, messageData) => async (dispatch) => {
  if (!id) {
    console.error("ID is missing when calling updateLeadershipMessageById");
    alert("Invalid ID for updating leadership message.");
    return;
  }
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/aboutPage/updateLeadershipMessage/${id}`,
      messageData,
      getAuthHeaders() // Added authentication headers
    );
    dispatch(updateLeadershipMessage(response.data.data));
   // alert("Leadership message updated successfully!");
  } catch (error) {
    console.error("Error updating leadership message:", error);
    alert(`Error updating message: ${error.message || "Something went wrong"}`);
  }
};



export const deleteLeadershipMessageById = (id) => async (dispatch) => {
  try {
    await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/aboutPage/deleteLeadershipMessage/${id}`,
      getAuthHeaders() // Added authentication headers
    );
    dispatch({
      type: "DELETE_LEADERSHIP_MESSAGE",
      payload: id,
    });
    // alert("Leadership message deleted successfully!");
  } catch (error) {
    console.error("Error deleting leadership message:", error);
    alert(`Error deleting message: ${error.message || "Something went wrong"}`);
  }
};


export const addLeadershipMessage = (formData, onSuccess) => async (dispatch) => {
  try {
    const token = getToken();
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/aboutPage/addLeadershipMessage`,
      formData,
      { headers } // Added authentication headers
    );

    dispatch({ type: "ADD_LEADERSHIP_MESSAGE_SUCCESS", payload: response.data });

    // Trigger success callback
    if (onSuccess) onSuccess();
  } catch (error) {
    console.error("Error adding leadership message:", error.response?.data || error.message);
    dispatch({ type: "ADD_LEADERSHIP_MESSAGE_FAIL", payload: error.message });
  }
};

export const addCouncilMember = (formData, onSuccess) => async (dispatch) => {
  dispatch(addCouncilMemberStart());
  try {
    const token = getToken();
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/aboutPage/addBoardOfCouncil`,
      formData,
      { headers } // Added authentication headers
    );

    dispatch(addCouncilMemberSuccess(response.data.data));

    // Trigger success callback if provided
    if (onSuccess) onSuccess();
  } catch (error) {
    console.error("Error adding council member:", error.response?.data || error.message);
    dispatch(addCouncilMemberFailure(error.message || "Something went wrong"));
  }
};

export const fetchCouncilMembers = () => async (dispatch) => {
  dispatch(fetchCouncilMemberStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/aboutPage/getAllBoardOfCouncil`,
      getAuthHeaders() // Added authentication headers
    );
    //console.log(response.data)
    const messages = response?.data?.data || [];
    dispatch(fetchCouncilMemberSuccess(messages));
  } catch (error) {
    console.error("Error fetching Council Members:", error);
    dispatch(
      fetchCouncilMemberFailure(
        error.response?.data?.message || "Failed to fetch council members"
      )
    );
  }
};

export const updateCouncilMember = (id, messageData) => async (dispatch) => {
  if (!id) {
    console.error("ID is missing when calling updateCouncilMember");
    alert("Invalid ID for updating council member.");
    return;
  }
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/aboutPage/updateBoardOfCouncil/${id}`,
      messageData,
      getAuthHeaders() // Added authentication headers
    );
    dispatch(updateCouncilMemberSuccess(response.data.data));
   // alert("Leadership message updated successfully!");
  } catch (error) {
    console.error("Error updating council member:", error);
    alert(`Error updating council member: ${error.message || "Something went wrong"}`);
  }
};


export const deleteCouncilMemberById = (id) => async (dispatch) => {
  try {
    await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/aboutPage/deleteBoardOfCouncil/${id}`,
      getAuthHeaders() // Added authentication headers
    );
    dispatch({
      type: "DELETE_COUNCIL_MEMBER",
      payload: id,
    });
    // alert("Council member deleted successfully!");
  } catch (error) {
    console.error("Error deleting council member:", error);
    alert(`Error deleting council member: ${error.message || "Something went wrong"}`);
  }
};
export const addBoardMember = (formData, onSuccess) => async (dispatch) => {
  dispatch(addBoardMemberStart());
  try {
    const token = getToken();
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/aboutPage/addBoardOfManagement`,
      formData,
      { headers } // Added authentication headers
    );

    dispatch(addBoardMemberSuccess(response.data.data));

    // Trigger success callback if provided
    if (onSuccess) onSuccess();
  } catch (error) {
    console.error("Error adding board member:", error.response?.data || error.message);
    dispatch(addBoardMemberFailure(error.message || "Something went wrong"));
  }
};

export const fetchBoardMembers = () => async (dispatch) => {
  dispatch(fetchBoardMemberStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/aboutPage/getAllBoardOfManagement`,
      getAuthHeaders() // Added authentication headers
    );
    //console.log(response.data)
    const messages = response?.data?.data || [];
    dispatch(fetchBoardMemberSuccess(messages));
  } catch (error) {
    console.error("Error fetching board Members:", error);
    dispatch(
      fetchBoardMemberFailure(
        error.response?.data?.message || "Failed to fetch board members"
      )
    );
  }
};

export const updateBoardMember = (id, messageData) => async (dispatch) => {
  if (!id) {
    console.error("ID is missing when calling updateBoardMember");
    alert("Invalid ID for updating Board Member.");
    return;
  }
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/aboutPage/updateBoardOfManagement/${id}`,
      messageData,
      getAuthHeaders() // Added authentication headers
    );
    dispatch(updateBoardMemberSuccess(response.data.data));
   // alert("Leadership message updated successfully!");
  } catch (error) {
    console.error("Error updating Board member:", error);
    alert(`Error updating Board member: ${error.message || "Something went wrong"}`);
  }
};

export const deleteBoardMemberById = (id) => async (dispatch) => {
  try {
    await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/aboutPage/deleteBoardOfManagement/${id}`,
      getAuthHeaders() // Added authentication headers
    );
    dispatch({
      type: "DELETE_BOARD_MEMBER",
      payload: id,
    });
    // alert("Board member deleted successfully!");
  } catch (error) {
    console.error("Error deleting Board member:", error);
    alert(`Error deleting Board member: ${error.message || "Something went wrong"}`);
  }
};

export const addStudiesMember = (formData, onSuccess) => async (dispatch) => {
  dispatch(addStudiesMemberStart());
  try {
    const token = getToken();
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/aboutPage/addBoardOfStudies`,
      formData,
      { headers } // Added authentication headers
    );

    dispatch(addStudiesMemberSuccess(response.data.data));

    // Trigger success callback if provided
    if (onSuccess) onSuccess();
  } catch (error) {
    console.error("Error adding Studies member:", error.response?.data || error.message);
    dispatch(addStudiesMemberFailure(error.message || "Something went wrong"));
  }
};

export const fetchStudiesMembers = () => async (dispatch) => {
  dispatch(fetchStudiesMemberStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/aboutPage/getAllBoardOfStudies`,
      getAuthHeaders() // Added authentication headers
    );
    //console.log(response.data)
    const messages = response?.data?.data || [];
    dispatch(fetchStudiesMemberSuccess(messages));
  } catch (error) {
    console.error("Error fetching Studies Members:", error);
    dispatch(
      fetchStudiesMemberFailure(
        error.response?.data?.message || "Failed to fetch Studies members"
      )
    );
  }
};

export const updateStudiesMember = (id, messageData) => async (dispatch) => {
  if (!id) {
    console.error("ID is missing when calling updateStudiesMember");
    alert("Invalid ID for updating Board Of studies Member.");
    return;
  }
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/aboutPage/updateBoardOfStudies/${id}`,
      messageData,
      getAuthHeaders() // Added authentication headers
    );
    dispatch(updateStudiesMemberSuccess(response.data.data));
   // alert("Leadership message updated successfully!");
  } catch (error) {
    console.error("Error updating Board Of studies member:", error);
    alert(`Error updating Board Of studies member: ${error.message || "Something went wrong"}`);
  }
};

export const deleteStudiesMemberById = (id) => async (dispatch) => {
  try {
    await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/aboutPage/deleteBoardOfStudies/${id}`,
      getAuthHeaders() // Added authentication headers
    );
    dispatch({
      type: "DELETE_STUDIES_MEMBER",
      payload: id,
    });
    // alert("Board member deleted successfully!");
  } catch (error) {
    console.error("Error deleting Studies member:", error);
    alert(`Error deleting Studies member: ${error.message || "Something went wrong"}`);
  }
};

export const fetchHistoryData = () => async (dispatch) => {
  console.log("Fetching history data...");
  dispatch(fetchHistoryStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/aboutPage/getHistory`,
      getAuthHeaders() // Added authentication headers
    );
    const historyData = response?.data?.data?.[0] || {}; // Get the first item from array
    dispatch(fetchHistorySuccess(historyData));
  } catch (error) {
    console.error("Error fetching history data:", error);
    dispatch(fetchHistoryFailure(error.response?.data?.message || "Failed to fetch history data"));
  }
};

export const updateHistoryData = (id, history) => async (dispatch) => {
  dispatch(updateHistoryStart()); // Start updating
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/homePage/aboutPage/updateHistory/${id}`,
      { history }, // Ensure request body is an object with "history" key
      getAuthHeaders() // Added authentication headers
    );

    dispatch(updateHistorySuccess(response.data)); // Use response data
  
  } catch (error) {
    console.error("Error updating history data:", error);
    dispatch(updateHistoryFailure(error.response?.data?.message || "Something went wrong"));
    alert(`Error updating history: ${error.response?.data?.message || "Something went wrong"}`);
  }
};